import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { InspectionsState } from "../types/inspections/InspectionsState";
import { RootState } from "../redux/store";
import {
    getInspectionsByOrgId,
    GetInspectionsRequestData
} from "../services/InspectionsServices";
import { DataSharingStatus } from "../constants/DataSharingConstants";

const initialState: InspectionsState = {
    Inspections: null,
    InspectionsStatus: "idle",
    selectedInspection: null,
    activeTab: 0,
    toggleDataSharingOptIn: undefined,
    dataSharingStatus: null,
    authorityMappings: undefined
};

export const inspectionsSlice = createSlice({
    name: "inspectionsSlice",
    initialState,
    reducers: {
        setSelectedInspection: (state, action: PayloadAction<string>) => {
            state.selectedInspection = action.payload;
        },
        setActiveTab: (state, action: PayloadAction<number>) => {
            state.activeTab = action.payload;
        },
        setToggleDataSharingOptIn: (
            state,
            action: PayloadAction<boolean | undefined>
        ) => {
            state.toggleDataSharingOptIn = action.payload;
        },
        setDataSharingStatus: (
            state,
            action: PayloadAction<DataSharingStatus | null>
        ) => {
            state.dataSharingStatus = action.payload;
        },
        setAuthorityMappings: (
            state,
            action: PayloadAction<Record<string, string[]> | undefined>
        ) => {
            state.authorityMappings = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getInspectionsThunk.fulfilled, (state, action) => {
                state.Inspections = action.payload;
                state.InspectionsStatus = "succeeded";
            })
            .addCase(getInspectionsThunk.pending, (state, _action) => {
                state.InspectionsStatus = "pending";
            })
            .addCase(getInspectionsThunk.rejected, (state, _action) => {
                state.InspectionsStatus = "failed";
                state.Inspections = null;
            });
    }
});

export const getInspectionsThunk = createAsyncThunk(
    "inspections/getInspections",
    async (requestData: GetInspectionsRequestData) => {
        return getInspectionsByOrgId(requestData);
    }
);

export const inspectionsSelector = (state: RootState) => state.Inspections;
export const inspectionsActiveTabSelector = (state: RootState) =>
    state.Inspections.activeTab;
export const inspectionsToggleDataSharingOptInSelector = (state: RootState) =>
    state.Inspections.toggleDataSharingOptIn;
export const inspectionsDataSharingStatusSelector = (state: RootState) =>
    state.Inspections.dataSharingStatus;
export const authorityMappingsSelector = (state: RootState) =>
    state.Inspections.authorityMappings;

export const {
    setSelectedInspection,
    setActiveTab,
    setToggleDataSharingOptIn,
    setDataSharingStatus,
    setAuthorityMappings
} = inspectionsSlice.actions;

export default inspectionsSlice.reducer;
